import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="phone-number-adoption"
export default class extends Controller {
  static targets = ["twilioSid"];

  connect() {
    this.validateInput();
  }

  validateInput() {
    if (this.hasTwilioSidTarget) {
      this.twilioSidTarget.addEventListener("input", (event) => {
        this.formatTwilioSid(event.target);
      });

      this.twilioSidTarget.addEventListener("paste", (event) => {
        // Allow paste, then format after a short delay
        setTimeout(() => {
          this.formatTwilioSid(event.target);
        }, 10);
      });
    }
  }

  formatTwilioSid(input) {
    let value = input.value.trim().toUpperCase();

    // Remove any non-alphanumeric characters except for the PN prefix
    value = value.replace(/[^A-Z0-9]/g, "");

    // Ensure it starts with PN
    if (value && !value.startsWith("PN")) {
      if (value.match(/^[A-F0-9]{32}$/)) {
        value = "PN" + value;
      }
    }

    // Limit to 34 characters (PN + 32 hex chars)
    if (value.length > 34) {
      value = value.substring(0, 34);
    }

    input.value = value;
    this.updateValidationState(input);
  }

  updateValidationState(input) {
    const isValid = this.isValidTwilioSid(input.value);

    if (isValid) {
      input.classList.remove("is-invalid");
      input.classList.add("is-valid");
    } else if (input.value.length > 0) {
      input.classList.remove("is-valid");
      input.classList.add("is-invalid");
    } else {
      input.classList.remove("is-valid", "is-invalid");
    }
  }

  isValidTwilioSid(value) {
    return /^PN[A-F0-9]{32}$/i.test(value);
  }
}
